import React, { CSSProperties, FC, useState } from 'react'
import cn from 'classnames'

import styles from './styles.module.scss'

interface IProps {
  leftTitle: string,
  rightTitle: string,
  switchStyle?: CSSProperties,
  buttonStyle?: CSSProperties
  onSwitchClick: (value: SwitchPositionType) => void
  initialPosition: SwitchPositionType
  oneButton: boolean
}


enum SwitchPositionType {
  left,
  right
}

const CustomSwitch: FC<IProps> = ({
                                    leftTitle,
                                    rightTitle,
                                    switchStyle,
                                    buttonStyle,
                                    initialPosition,
                                    onSwitchClick,
                                    oneButton
                                  }) => {
  const [switchPosition, setSwitchPosition] = useState<SwitchPositionType>(initialPosition)

  const handlerSwitchClick = (value: SwitchPositionType) => {
    if (switchPosition === value) return
    setSwitchPosition(value)
    onSwitchClick(value)
  }

  return (
    <div style={switchStyle} className={styles.switch}>
      <div className={styles.switchInner}>
        <div style={buttonStyle}
             className={cn({
               [styles.switchBtn]: true,
               [styles.oneButton]: oneButton,
               [styles.positionRight]: switchPosition === SwitchPositionType.right
             })}/>
        <div className={cn({
          [styles.left]: true,
          [styles.oneButton]: oneButton,
          [styles.inactive]: switchPosition !== SwitchPositionType.left
        })}
             onClick={() => handlerSwitchClick(SwitchPositionType.left)}>
          {leftTitle}
        </div>
        {!oneButton
          ? <div className={cn({
            [styles.right]: true,
            [styles.inactive]: switchPosition !== SwitchPositionType.right
          })}
                 onClick={() => handlerSwitchClick(SwitchPositionType.right)}>
            {rightTitle}
          </div>
          : null}
      </div>

    </div>
  )
}

export default CustomSwitch
